export const UNLOCK_TEAM_FOLDER_SERVER_MESSAGE = 'Cannot lock a document in a TEAM FOLDER library';
export const UNLOCK_DOC_NOT_IN_CONTROL_STATE_MESSAGE = 'Cannot unlock a document that is not in the control state';
export const LIST_UNLOCKED_DOCS_TIMEOUT = 2000;
